import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18next";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18next";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<I18nextProvider i18n={i18n}>
		{" "}
		<App />
	</I18nextProvider>
);

reportWebVitals();
